import type { ConditionDescriptor } from "../../../../../../../../api/types/fieldConfigurationTypes";
import type { ConditionField } from "../../../../../../../../api/types/svTypes";
import { createNarrowingConditionDescriptor } from "../../../../utilities/conditionDescriptorHelper";

export const getFiltersToApply = (conditions: ConditionField[], field: ConditionField): ConditionDescriptor[] => {
  const filters: ConditionDescriptor[] = [];
  for (let i = 0; i < conditions.length; i++) {
    const condition = conditions[i];
    if (condition === undefined || condition.meta.name === field.meta.name) {
      break;
    }
    const filter = createNarrowingConditionDescriptor(condition);
    if (filter !== undefined) {
      filters.push(filter);
    }
  }

  return filters;
};
